import React, { useState } from 'react'
import ResponseMessage from "../../../../../common/modal/ResponseMessage";
import Modal from '../../../../../common/modal/Modal'
import useMemberTable from '../../context/MemberTableContext'
import Button from '../../../../../common/button/Button'
import { modalBulkActionsId, modalBulkConfirmationMessageId } from './Utils'
import { formRequest } from '../../form/Utils';
import Icons from '../../../../../common/icons/Icons';
import { HandleShowCloseModal } from '../../../../../common/modal/HandleShowCloseModal';
import MicroModal from 'micromodal';


const BulkModalConfirmation = () => {

  const { selectedBulkUser, selectedModal, refetchMembers, refetchPendingInvites } = useMemberTable()
  const [ responseMessage, setResponseMessage ] = useState('')

  const membersBulkConfirmation = Object.values(modalBulkActionsId.members).map(item => item.request) ?? []
  const pendingInvitesBulkConfirmation = Object.values(modalBulkActionsId.pendingInvites).map(item => item.request) ?? []
  const hasRefetch =  membersBulkConfirmation.includes( selectedBulkUser.modal?.request ) ? refetchMembers 
                    : pendingInvitesBulkConfirmation.includes( selectedBulkUser.modal?.request ) ? refetchPendingInvites : null

  const formData = new FormData()
  formData.append('action', selectedBulkUser.modal?.request)

  if( selectedBulkUser && membersBulkConfirmation.includes( selectedBulkUser.modal?.request ) ){

    const memberId = selectedBulkUser.users.map(user => user.userId)
    const role =  selectedBulkUser.modal?.request === 'msync_bulk_member_set_as_manager' ? 'manager' 
                : selectedBulkUser.modal?.request === 'msync_bulk_member_set_as_member' && 'member' 

    formData.append('team_id', selectedBulkUser.users[0].teamId)
    formData.append('member_id[]', JSON.stringify(memberId))
    formData.append('role',  role)
    formData.append('nonce', group_dashboard.nonce_members)

  }else if( selectedBulkUser && pendingInvitesBulkConfirmation.includes( selectedBulkUser.modal?.request ) ){

    const invitationId = selectedBulkUser.users.map(user => user.invitationId)

    let wpNonce
    switch ( selectedBulkUser.modal?.action ) {
      case 'invitation_set_as_manager':
        wpNonce = selectedBulkUser.users.map(item => item.invitationWpNonce?.invitationSetAsManager)
        break;
      case 'invitation_set_as_member':
        wpNonce = selectedBulkUser.users.map(item => item.invitationWpNonce?.invitationSetAsMember)
        break;
      case 'invitation_resend':
        wpNonce = selectedBulkUser.users.map(item => item.invitationWpNonce?.invitationResend)
        break;
      case 'invitation_revoke':
        wpNonce = selectedBulkUser.users.map(item => item.invitationWpNonce?.invitationRevoke)
        break;
    }

    formData.append('invitation_team_id', selectedBulkUser.users[0].invitationTeamId)
    formData.append('invitation_id[]', JSON.stringify(invitationId))
    formData.append('invitation_action', selectedBulkUser.modal?.action)
    formData.append('invitation_wpnonce[]', JSON.stringify(wpNonce))

  }

  const { isLoading, isFetching, isError, error, refetch, data } = formRequest( formData, setResponseMessage, hasRefetch )

  const handleBackToSelectedModal = () => {
    HandleShowCloseModal( selectedModal, modalBulkConfirmationMessageId )
  }
  
  return (
    <Modal 
      modalId={ modalBulkConfirmationMessageId }
      showModalHeader={ false }
      buttonTitle={''}
      modalClassNames={'msync-members-custom-modal'}
      >
      <header className="msync-modal__header">
        <div className="msync-modal__header__title">
          {
            selectedModal &&
            <button onClick={ () => handleBackToSelectedModal() }>
              <Icons type="arrow-tail-left" />
            </button>
          }
          <h2 className="msync-modal__header__title__text msync-modal__title">{ selectedBulkUser.modal?.title }</h2>
        </div>

        <Button 
          className="msync-modal__close" 
          aria-label="Close modal" 
          onClick={()=>MicroModal.close( modalBulkConfirmationMessageId )}
        >
          <Icons type='close' />
          <span className="msync-visually-hidden">Close <kbd>ESC</kbd></span>
        </Button>
      </header>
      { 
        isError
        ? <ResponseMessage response={{
            type: 'error',
            message: error.message
          }} />
        : responseMessage && (
        <ResponseMessage response={{
          type: data ? 'success' : 'error',
          message: responseMessage
        }} /> )
      }
      <main className="msync-modal__body">
        <span>
          {
            selectedBulkUser.modal?.content
            ? selectedBulkUser.modal?.content
            : 'Confirm your choice to proceed.'
          }
        </span>
        {
          selectedBulkUser && 
          <div className='msync-selected-user-container'>
            <span>Selected User(s)</span>
            <ul>
              {
                selectedBulkUser.users.map((data) => (
                  <li key={ membersBulkConfirmation.includes( selectedBulkUser.modal?.request ) ? data.userId : data.invitationId }>
                    { membersBulkConfirmation.includes( selectedBulkUser.modal?.request ) ? data.user : data.invitationName }
                    &nbsp;( { membersBulkConfirmation.includes( selectedBulkUser.modal?.request ) ? data.email : data.invitationEmail } )
                  </li>
                ))
              }
            </ul>
          </div>
        }
      </main>
      <footer className='msync-modal__footer'>
        <Button
          className="msync-button--is-style-outline msync-button--is-theme-destructive"
          type="button"
          name="Cancel"
          onClick={()=>MicroModal.close(modalBulkConfirmationMessageId)}
          aria-label="Close this dialog window"
        />
        <Button
          onClick={ () => refetch() }
          name={ isLoading || isFetching ? 'Loading...' : 'Confirm' }
          disabled={ isLoading || isFetching ? true : false }
        />
      </footer>
    </Modal>
  )

}

export default BulkModalConfirmation
